declare global {
  interface String {
    withSpaceAfterCapitalLetters(): string;
    capitaliseFirstString(): string;
    upperStringToLowerCase(): string;
  }
}

const load = () => {
  String.prototype.withSpaceAfterCapitalLetters = function () {
    return this.replace(/([A-Z])/g, ' $1').trim();
  };

  String.prototype.upperStringToLowerCase = function () {
    return this.replace(/\b[A-Z0-9]{2,}\b/g, (string) => string.toLowerCase());
  };

  String.prototype.capitaliseFirstString = function () {
    return this.replace(/(^\w{1})|(\s+\w{1})/g, (string) => string.toUpperCase());
  };

  return true;
};

export default load();
